import { useFetchQuantifyReportDataForGlobalFilters } from '@modules/dashboard/hooks/useFetchDashboardQuantifyReportData/useFetchQuantifyReportDataForGlobalFilters';
import { useUpdateQuantifyStateForGlobalFilters } from '@modules/dashboard/hooks/useFetchDashboardQuantifyReportData/useUpdateQuantifyStateForGlobalFilters';

interface UseFetchDashboardQuantifyReportDataOptions {
  skip: boolean;
}

export const useFetchDashboardQuantifyReportData = ({
  skip,
}: UseFetchDashboardQuantifyReportDataOptions) => {
  useUpdateQuantifyStateForGlobalFilters({
    skip,
  });

  const isLoading = useFetchQuantifyReportDataForGlobalFilters();

  return isLoading;
};
